import { render, staticRenderFns } from "./ExhibitUpdate.vue?vue&type=template&id=30973702&scoped=true&"
import script from "./ExhibitUpdate.vue?vue&type=script&lang=js&"
export * from "./ExhibitUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30973702",
  null
  
)

export default component.exports